import React from 'react';
import UserAgreement from './user-agreement.tsx';

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function TermsAndConditionsView() {
	return (
		<UserAgreement
			id="privacy-policy"
			title="Privacy Policy for the Morgan Car Configurator"
			sections={[
				{
					title: 'Information Collection and Use',
					description:
						<div>
							<p>We collect several types of information from and about users of our Site, including:</p>
							<ul>
								<li>Personal Information: information that identifies you personally, such as your name, email address, postal address, phone number, and other contact information.</li>
								<li>Usage Information: information about your use of our Site, such as your IP address, device type, browser type, pages you visit, and other usage statistics.</li>
								<li>Demographic Information: information about your demographic characteristics, such as your age, gender, location, and interests.</li>
							</ul>
							<p>We may use the information we collect from you for the following purposes:</p>
							<ul>
								<li>To provide and maintain our Site</li>
								<li>To improve our Site and services</li>
								<li>To personalize your experience</li>
								<li>To communicate with you</li>
								<li>To analyze usage and trends</li>
								<li>To comply with legal obligations</li>
							</ul>
							<p>We will only collect and use your Personal Information for the purposes disclosed to you, unless you authorize us to use it for other purposes.</p>
						</div>

				},
				{
					title: 'Sharing Your Information',
					description:
						<div>
							<p>We may share your Personal Information with our affiliates, partners, and service providers for the purposes described in this Privacy Policy. We may also share your information:</p>
							<ul>
								<li>With our legal and financial advisors</li>
								<li>With law enforcement and government authorities to comply with legal obligations or to protect our rights and interests</li>
								<li>In connection with a merger, acquisition, or other corporate transaction</li>
								<li>With your consent or at your direction</li>
							</ul>
							<p>We will not sell or rent your Personal Information to third parties for their own marketing purposes without your consent.</p>
						</div>

				},
				{
					title: 'Cookies and Similar Technologies',
					description:
						<div>
							<p>We use cookies and similar technologies to collect and store information about your use of our Site. Cookies are small data files that are placed on your device when you visit a website. We use cookies for the following purposes:</p>
							<ul>
								<li>To operate and improve our Site</li>
								<li>To personalize your experience</li>
								<li>To analyze usage and trends</li>
								<li>To serve ads based on your interests</li>
							</ul>
							<p>You can control the use of cookies through your browser settings and other tools. However, if you disable cookies, you may not be able to use certain features of our Site.</p>
						</div>

				},
				{
					title: 'Security',
					description:
						<div>
							<p>We take reasonable measures to protect your Personal Information from unauthorized access, disclosure, and use. However, no data transmission or storage system is 100% secure. We cannot guarantee the security of your Personal Information.</p>
						</div>

				},
				{
					title: 'Third-Party Links',
					description:
						<div>
							<p>Our Site may contain links to third-party websites or services. These links are provided for your convenience only. We do not endorse or control these third-party sites, and we are not responsible for their privacy practices or content.</p>
						</div>

				},
				{
					title: 'Children\'s Privacy',
					description:
						<div>
							<p>Our Site is not intended for children under the age of 13. We do not knowingly collect Personal Information from children under 13. If you are a parent or guardian and believe that your child has provided us with Personal Information, please contact us immediately.</p>
						</div>

				},
				{
					title: 'Your Rights and Choices',
					description:
						<div>
							<p>You have certain rights and choices regarding your Personal Information, including:</p>
							<ul>
								<li>The right to access and receive a copy of your Personal Information</li>
								<li>The right to request that we correct, amend, or delete your Personal Information</li>
								<li>The right to object to the processing of your Personal Information</li>
								<li>The right to withdraw your consent to the processing of your Personal Information</li>
								<li>The right to lodge a complaint with a supervisory authority</li>
							</ul>
							<p>To exercise your rights or make a request, please contact us using the information below.</p>
						</div>

				},
				{
					title: 'Changes to This Privacy Policy',
					description:
						<div>
							<p>This Privacy Policy is effective as of 28 March 2023 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</p>
							<p>We reserve the right to update or change our Privacy Policy at any time, and you should check this Privacy Policy periodically. Your continued use of the Site after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>
						</div>

				},
				{
					title: 'Contact Us',
					description:
						<div>
							<p>If you have any questions or concerns about this Privacy Policy, please contact us at contact@morgan-motor.co.uk.</p>
						</div>

				}
			]}
		/>
	);
}